import React from "react";

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

export const getMessages = async (buildingId) => {
    try {
        const response = await fetch(`${API_URL}/api/Message/GetMessages/${buildingId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}` // Add if you use JWT tokens
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        
        if (err.message.includes('404')) {
            throw new Error('API endpoint not found. Please check if the backend server is running.');
        } else if (err.message.includes('Failed to fetch')) {
            throw new Error('Cannot connect to the server. Please check if the backend is running.');
        } else {
            throw err;
        }
    }
};

export const createMessage = async (messageData) => {
    try {
        const response = await fetch(`${API_URL}/api/Message`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(messageData)
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw err;
    }
};

export const updateMessage = async (messageId, messageData) => {
    try {
        const response = await fetch(`${API_URL}/api/Message/${messageId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(messageData)
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw err;
    }
};

export const deleteMessage = async (messageId) => {
    try {
        const response = await fetch(`${API_URL}/api/Message/${messageId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw err;
    }
};

// NEW: Send message via email to all building users
export const sendMessageEmails = async (buildingId, messageId) => {
    try {
        const response = await fetch(`${API_URL}/api/Message/SendMessageEmails`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                BuildingId: buildingId.toString(),
                MessageId: messageId
            })
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        // Check if the response is JSON
        const contentType = response.headers.get('Content-Type');
        if (!contentType || !contentType.includes('application/json')) {
            const text = await response.text();
            throw new Error('Server returned non-JSON response');
        }

        return await response.json();
    } catch (err) {
        
        if (err.message.includes('404')) {
            throw new Error('API endpoint not found. Please check if the backend server is running.');
        } else if (err.message.includes('Failed to fetch')) {
            throw new Error('Cannot connect to the server. Please check if the backend is running.');
        } else {
            throw err;
        }
    }
};